import React, { FC, ComponentClass } from 'react';
import ReactDOM from 'react-dom';

export interface IOverlayProps<T = {}> {
    component: FC<React.PropsWithChildren<T>> | ComponentClass<T>;
    componentProps: T;
}

export const Overlay: FC<React.PropsWithChildren<IOverlayProps>> = ({
    component: Component,
    componentProps
}) =>
    ReactDOM.createPortal(
        <Component {...componentProps} />,
        document.getElementById('overlay-root')
    );
